<template>
  <Form
    :action-type="actionType"
    :subtitle="subtitle"
    :disabled="wasDisabled"
    :fallback-link="fallbackLink"
    :form-body="form"
    :show-preloader="isLoadingNow"
    :removal-callback="remove "
    :starting-stock-balance="form.balance"
    @on-submit="submit"
    @on-edit="setEditMode(true)"
    @on-cancel="setEditMode(false)"
  >
    <template slot="fields">
      <div class="row">
        <div class="col-lg-12">
          <div
            v-for="(value, key, index) in mainLabels"
            :key="index"
            class="col-lg-6 form-group"
          >
            <fieldset>
              <label>
                {{ value }}
                <span
                  v-if="isRequiredField(validationSchema[key])"
                  class="field__label_required"
                  >*</span
                >
              </label>
              <textarea
                v-if="value === 'Текстовое описание'"
                class="form-control"
                :disabled="actionType === 'read'"
                :maxlength="maxLength[key]"
                placeholder="Отсутствует"
                v-model.trim="form[key]"
              />
              <input
                v-else
                class="form-control"
                :name="key"
                :maxlength="maxLength[key]"
                placeholder="Отсутствует"
                :disabled="actionType === 'read'"
                v-model.trim="form[key]"
              />
            </fieldset>
          </div>
        </div>
      </div>
      <Sublist
        v-for="(labels, index) in [vendorCodeLabels, characterLabels]"
        :key="index"
        :subtitle="getSublistSubtitle(labels)"
      >
        <template slot="fields">
          <div class="row">
            <div class="col-lg-12">
              <div
                v-for="(value, key, index) in labels"
                :key="index"
                class="col-lg-6 form-group"
              >
                <fieldset>
                  <label>
                    {{ value }}
                    <span
                      v-if="isRequiredField(validationSchema[key])"
                      class="field__label_required"
                      >*</span
                    >
                  </label>
                  <input
                    class="form-control"
                    placeholder="Отсутствует"
                    :name="key"
                    :maxlength="maxLength[key]"
                    :disabled="actionType === 'read'"
                    v-model.trim="form[key]"
                  />
                </fieldset>
              </div>
            </div>
          </div>
          <div v-if="index !== 0" class="row">
            <div class="col-lg-12">
              <div class="col-lg-6 form-group">
                <fieldset>
                  <label>
                    Состав
                    <span class="field__label_required">*</span>
                  </label>
                  <textarea
                    class="form-control"
                    :disabled="actionType === 'read'"
                    :maxlength="maxLength['structure']"
                    placeholder="Отсутствует"
                    v-model.trim="form.structure"
                  />
                </fieldset>
              </div>
            </div>
          </div>
        </template>
      </Sublist>
      <div class="col-lg-6">
        <label class="control-label">
          Изображение
          <label v-if="actionType !== 'read'" class="field__label_required">
            *
          </label>
        </label>
        <ImageInput
          :preview-image="previewImage"
          :only-preview-image="actionType === 'read'"
          @on-select-file="setImage"
          @on-delete="deleteImage"
        />
      </div>
    </template>
  </Form>
</template>

<script>
import { validationMixin } from "vuelidate";
import schemas from "@/stock/validation-schemas";
import { stockComponentService } from "@/stock/api-services";

import Sublist from "@/_shared/features/form/Sublist";
import ImageInput from "@/_shared/features/form/ImageInput";
import Form from "@/_shared/widgets/Form";

import { useForm, useNotification, useImageField } from "@/_shared/mixins";
import { formsFields } from "@/stock/constants";

import { objectHelper } from "@/_shared/utils";
const { createCopy, createFromKeys } = objectHelper;
export default {
  mixins: [
    validationMixin,
    useForm,
    useNotification,
    useImageField,
  ],
  components: {
    ImageInput,
    Form,
    Sublist,
  },
  data() {
    return {
      fallbackLink: "/cloths",
      entityName: {
        readonly: "Ткань",
        modify: "ткани",
      },
      form: createFromKeys(formsFields.cloth.labels),
    };
  },
  validations() {
    return {
      form: this.validationSchema,
    };
  },
  async created() {
    const addingFields = createCopy(this.form);
    const callback = stockComponentService.get("cloths");
    await this.setFormFields(addingFields, callback).then(() => {
      this.checkPreviewImageExistence();
    });
  },
  computed: {
    validationSchema() {
      return schemas.cloth;
    },
    maxLength() {
      return formsFields.cloth.maxlength;
    },
    mainLabels() {
      const { name, type, barcode, additional_info, text_description } =
        formsFields.cloth.labels;
      return {
        name,
        type,
        barcode,
        additional_info,
        text_description,
      };
    },
    characterLabels() {
      const { color, width, winding, density, unit_price } =
        formsFields.cloth.labels;
      return { color, width, winding, density, unit_price };
    },
    vendorCodeLabels() {
      const { vendor_code, provider_vendor_code } = formsFields.cloth.labels;
      return { vendor_code, provider_vendor_code };
    },
  },
  methods: {
    async remove() {
      return await stockComponentService.remove([this.form.id], 'cloth');
    },
    async submit() {
      const callback = async () => {
        return await this.encodeImage()
          .then(async () => {
            return await stockComponentService[this.actionType](
              this.form, "cloth", this.image,
            );
          })
          .catch((error) => {
            throw new Error(error.message);
          });
      };
      await this.sendForm(callback);
    },
    getSublistSubtitle(labels = {}) {
      return labels.vendor_code ? "Артикулы" : "Характеристики";
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/stock/pages/ClothForm.vue